import { strToColor as l, ColorName as w, Colors as b } from "./configuration/types.js";
import { jsx as n, jsxs as p } from "react/jsx-runtime";
import { memo as D, useMemo as u, useCallback as y } from "react";
import { u as a } from "./styled-components.browser.esm-BFmoFexH.js";
import { ColoredElementWithRadius as T } from "@biron-data/react-components";
import { Col as m, Select as F, Row as h, Radio as C } from "antd";
import { useLanguageResolver as M } from "@biron-data/react-contexts";
var s = /* @__PURE__ */ ((r) => (r.greenToRed = "greenToRed", r.redToGreen = "redToGreen", r.baseDarkToLight = "baseDarkToLight", r.baseLightToDark = "baseLightToDark", r))(s || {});
const X = D(({
  value: r,
  onChange: t
}) => {
  const e = M(), d = u(() => Array.from(l.entries()).map(([o, g]) => ({
    label: /* @__PURE__ */ n(T, { $color: g }),
    value: o
  })), []), i = u(() => Object.keys(s).map((o) => {
    const g = A(o, (r == null ? void 0 : r.base) ?? w["blue-border"]);
    return /* @__PURE__ */ n(L, { value: o, checked: (r == null ? void 0 : r.type) === o, children: /* @__PURE__ */ n(k, { $gradientStops: g }) }, o);
  }), [r]), c = y((o) => {
    r && t && t({
      ...r,
      type: o
    });
  }, [t, r]);
  return /* @__PURE__ */ p(E, { children: [
    /* @__PURE__ */ n($, { children: /* @__PURE__ */ p(R, { children: [
      /* @__PURE__ */ n(f, { span: 8, children: /* @__PURE__ */ n("div", { children: e.get("configuration-metric-options.display.gradient.base") }) }),
      /* @__PURE__ */ n(m, { span: 6, children: /* @__PURE__ */ n(F, { value: r == null ? void 0 : r.base, options: d, onChange: (o) => {
        r && t && t({
          ...r,
          base: o
        });
      } }) })
    ] }) }),
    /* @__PURE__ */ n(G, { children: /* @__PURE__ */ p(h, { children: [
      /* @__PURE__ */ p(f, { span: 8, children: [
        /* @__PURE__ */ n("div", { children: e.get("configuration-metric-options.display.gradient.max") }),
        /* @__PURE__ */ n("div", { children: e.get("configuration-metric-options.display.gradient.min") })
      ] }),
      /* @__PURE__ */ n(m, { span: 16, children: /* @__PURE__ */ n(S, { value: r == null ? void 0 : r.type, onChange: (o) => {
        c(o.target.value);
      }, children: i }) })
    ] }) })
  ] });
}), R = a(h)`
    width: 100%;
`, $ = a.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
`, k = a.div`
    width: 22px;
    height: 72px;
    border-radius: var(--main-border-radius);
    margin: 10px;
    ${({ $gradientStops: r }) => `
      background: linear-gradient(180deg, ${r.map(([t, e]) => `${t} ${e}%`)});
    `}
`, E = a(h)`
    width: 100%;
    flex-direction: column;
    gap: 10px;
`, G = a.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`, S = a(C.Group)`
    // Override ant-radio-group in order to properly align content

    &&& {
        display: flex;
        gap: 10px;
        border: none;
        width: 100%;
        overflow: hidden;
        .ant-radio-button {

        }

        .ant-radio-button-checked {
            border: 2px solid var(--primary);
            border-radius: var(--main-border-radius);
        }
    }
`, L = a(C.Button)`
    width: 52px;
    height: 92px;
    padding: 0;
`, f = a(m)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`, x = (r, t) => {
  if (r = r.replace(/^#/, ""), r.length === 3 && (r = r.split("").map((o) => o + o).join("")), r.length !== 6)
    throw new Error("Invalid HEX color.");
  let e = parseInt(r.substring(0, 2), 16), d = parseInt(r.substring(2, 4), 16), i = parseInt(r.substring(4, 6), 16);
  e = Math.round(Math.min(255, Math.max(0, e + (255 - e) * t / 100))), d = Math.round(Math.min(255, Math.max(0, d + (255 - d) * t / 100))), i = Math.round(Math.min(255, Math.max(0, i + (255 - i) * t / 100)));
  const c = (o) => o.toString(16).padStart(2, "0");
  return `#${c(e)}${c(d)}${c(i)}`;
}, j = (r, t) => {
  switch (r) {
    case s.greenToRed:
      return ["#4DE59C", "#4DE54D", "#FFC500", "#F28C5A", "#F15068"];
    case s.redToGreen:
      return ["#F15068", "#F28C5A", "#FFC500", "#4DE54D", "#4DE59C"];
    case s.baseDarkToLight:
      return [l.get(t), x(l.get(t) ?? b.blue_border, 70)];
    case s.baseLightToDark:
      return [x(l.get(t) ?? b.blue_border, 70), l.get(t)];
    default:
      return [];
  }
}, A = (r, t) => {
  const e = j(r, t ?? w["blue-border"]);
  return Array.from({ length: e.length }, (d, i) => Math.round(i * 100 / (e.length - 1))).map((d, i) => [e[i], d]);
};
export {
  s as G,
  A as a,
  X as b,
  j as g,
  x as s
};
//# sourceMappingURL=GradientSelector.utils-BKTc3JRX.js.map
